import { get, isEmpty } from 'lodash';
import { v4 as uuid } from 'uuid';
import { LEARNING_ASSET_CATEGORIES_BY_NAME, LEARNING_ASSET_TYPES, SECTION_ITEM_TYPES } from '../Constants';


export const isAvailable = (learningAsset = {}, currentUserCompany = {}) => {
    const { subscriptionType = '' } = learningAsset;
    if (subscriptionType.toLocaleUpperCase() === 'AvailableForAll'.toLocaleUpperCase()) {
        return true;
    }
    const licenses = get(currentUserCompany, 'trackLicenses', []);
    const hasAsset = licenses.filter((asset) => asset.trackId === learningAsset._id).length;
    if (subscriptionType.toLocaleUpperCase() === 'ExclusiveCompanyLicense'.toLocaleUpperCase() && hasAsset) {
        return true;
    }
    return false;
};

export const isLearningAssetCourseType = (type) =>
    type === LEARNING_ASSET_TYPES.TRACK ||
    type === LEARNING_ASSET_TYPES.IMPACT_PROJECT;

export const getReflectionDefaults = (sectionId) => {
    const yesId = uuid();
    const noId = uuid();
    const chooseManyId1 = uuid();
    const shortEssayId1 = uuid();
    const chooseManyId2 = uuid();
    const chooseOneId = uuid();

    return {
        type: 'REFLECTION',
        name: 'Reflect On Your Experience',
        subtitle: "Whether you did your small action or not, there's something to learn for next time.",
        durationId: 'dd83face710c4c70a5d2ef653c13571a',
        participants: [
            {
                id: uuid(),
                type: 'all'
            },
            {
                id: yesId,
                type: 'yesRole'
            },
            {
                id: noId,
                type: 'noRole'
            }
        ],
        sections: [
            {
                id: sectionId,
                sectionIcon: 'asterisk',
                name: 'New Section',
                sectionItems: [
                    {
                        id: uuid(),
                        sectionId,
                        name: 'YES/NO',
                        type: 'Choose One Path',
                        minutes: 0,
                        isActive: true,
                        isVisible: false,
                        dataScope: 'solo',
                        startsOn: 1,
                        startsAfter: 'start',
                        transition: 'fade',
                        targetParticipantRole: 'all',
                        content: {
                            description:
                                '<p><span class="fr-class-text-style-3">Did you do your small action?</span></p>',
                            options: [
                                {
                                    image: '',
                                    choice: 'yesRole',
                                    id: yesId,
                                    label: 'YES'
                                },
                                {
                                    label: 'NO',
                                    image: '',
                                    choice: 'noRole',
                                    id: noId
                                }
                            ],
                            displayType: 'buttons'
                        }
                    },
                    {
                        id: uuid(),
                        sectionId,
                        name: 'Action Accomplished',
                        type: 'Dynamic Rich Text',
                        minutes: 0,
                        isActive: true,
                        isVisible: false,
                        dataScope: 'solo',
                        startsOn: 1,
                        startsAfter: 'start',
                        transition: 'fade',
                        targetParticipantRole: 'yesRole',
                        content: {
                            blocks: [
                                {
                                    id: uuid(),
                                    wrapText: true,
                                    layout: 'LEFT_TEXT_RIGHT_IMAGE',
                                    description:
                                        '<h2>You did it!</h2><p>You followed through and applied what you learned.<br/><br/>Take a minute to celebrate as you finish the last step of reflection.</p>'
                                }
                            ]
                        }
                    },
                    {
                        id: uuid(),
                        sectionId,
                        name: 'Last Step: Reflect and Grow',
                        type: 'Review Previous Activities',
                        minutes: 0,
                        isActive: true,
                        isVisible: false,
                        dataScope: 'solo',
                        startsOn: 1,
                        startsAfter: 'start',
                        transition: 'fade',
                        targetParticipantRole: 'yesRole',
                        isRequired: false,
                        content: {
                            questionsToDisplay: [],
                            description:
                                "<p>Reflection creates the space to examine your actions and the impact they have.</p><p>In this activity, you'll reflect on your small action with <strong>three questions</strong>.</p>"
                        }
                    },
                    {
                        id: chooseManyId1,
                        sectionId,
                        name: 'What It Was Like',
                        type: 'Choose Many',
                        minutes: 0,
                        isActive: true,
                        isVisible: false,
                        dataScope: 'solo',
                        startsOn: 1,
                        startsAfter: 'start',
                        transition: 'fade',
                        targetParticipantRole: 'yesRole',
                        content: {
                            displayType: 'box',
                            description:
                                '<h2>1. What was it like to do this small action?</h2><p>Take your time and choose.</p><p>You can also add your thoughts in the "other" field.</p>',
                            options: [
                                {
                                    label: '<p>Made me curious and want to experiment more</p>',
                                    image: '',
                                    choice: uuid()
                                },
                                {
                                    label: '<p>Pushed me out of my comfort zone</p>',
                                    image: '',
                                    choice: uuid()
                                },
                                {
                                    label: '<p>Felt difficult to do well</p>',
                                    image: '',
                                    choice: uuid()
                                },
                                {
                                    label: '<p>Felt really good — like I was on the right track</p>',
                                    image: '',
                                    choice: uuid()
                                },
                                {
                                    label: '<p>Opened me to new possibilities</p>',
                                    image: '',
                                    choice: uuid()
                                },
                                {
                                    label: "<p>Didn't feel authentic for me</p>",
                                    image: '',
                                    choice: uuid()
                                },
                                {
                                    image: '',
                                    label: 'Other ',
                                    choice: uuid(),
                                    isOther: true
                                }
                            ]
                        }
                    },
                    {
                        id: shortEssayId1,
                        sectionId,
                        name: 'The Impact',
                        type: 'Short Essay',
                        minutes: 0,
                        isActive: true,
                        isVisible: false,
                        dataScope: 'solo',
                        startsOn: 1,
                        startsAfter: 'start',
                        transition: 'fade',
                        targetParticipantRole: 'yesRole',
                        content: {
                            hideCharacterCount: true,
                            description:
                                '<h2>2. What impact do you think the small action had?</h2><p>Try not to judge what happened, but instead be as factual as possible.</p><p>Answer in a few phrases or sentences.</p>'
                        }
                    },
                    {
                        id: uuid(),
                        sectionId,
                        name: 'Review Your Responses',
                        type: 'Show Previous Answers',
                        minutes: 0,
                        isActive: true,
                        isVisible: false,
                        dataScope: 'solo',
                        startsOn: 1,
                        startsAfter: 'start',
                        transition: 'fade',
                        targetParticipantRole: 'yesRole',
                        isRequired: false,
                        content: {
                            description:
                                "<h2>Consider how you want to grow from this experience.</h2><p>You'll record your thoughts when you answer the last question on the next screen.</p>",
                            questionsToDisplay: [
                                {
                                    id: uuid(),
                                    questionType: 'CHOOSE MANY',
                                    questionId: chooseManyId1
                                },
                                {
                                    id: uuid(),
                                    questionType: 'SHORT ESSAY',
                                    questionId: shortEssayId1
                                }
                            ]
                        }
                    },
                    {
                        id: uuid(),
                        sectionId,
                        name: 'Takeaway',
                        type: 'Short Essay',
                        minutes: 0,
                        isActive: true,
                        isVisible: false,
                        dataScope: 'solo',
                        startsOn: 1,
                        startsAfter: 'start',
                        transition: 'fade',
                        targetParticipantRole: 'yesRole',
                        content: {
                            hideCharacterCount: true,
                            description:
                                "<h2>3. What is the main thing you want to take from this experience?</h2><p>There's no right answer. Your honest response helps you grow in the way that's best for you.</p><p>You can also use this space to make a plan for what's next — whether that's practicing this action on your own, changing it to work better for you, or dropping it for now.</p>"
                        }
                    },
                    {
                        id: uuid(),
                        sectionId,
                        name: 'Wrap Up',
                        type: 'Dynamic Rich Text',
                        minutes: 0,
                        isActive: true,
                        isVisible: false,
                        dataScope: 'solo',
                        startsOn: 1,
                        startsAfter: 'start',
                        transition: 'fade',
                        targetParticipantRole: 'yesRole',
                        content: {
                            blocks: [
                                {
                                    id: uuid(),
                                    wrapText: true,
                                    layout: 'LEFT_TEXT_RIGHT_IMAGE',
                                    description:
                                        "<p>You're done!</p><p><strong>Learning, taking action, and reflecting help you build leadership skills over time.</strong></p>"
                                }
                            ]
                        }
                    },
                    {
                        id: uuid(),
                        sectionId,
                        name: 'Last Step: Reflect and Grow',
                        type: 'Review Previous Activities',
                        minutes: 0,
                        isActive: true,
                        isVisible: false,
                        dataScope: 'solo',
                        startsOn: 1,
                        startsAfter: 'start',
                        transition: 'fade',
                        targetParticipantRole: 'noRole',
                        content: {
                            description:
                                "<p>Thanks for sharing. <strong>Even when you don't take action, you can still benefit from reflection</strong>. It's ALL part of how you grow as a leader: learn, plan, try, reflect, try again... What matters most is that you keep going.</p><p>&nbsp;<br>In this activity, you'll answer <strong>three questions</strong> about not doing this small action.</p>"
                        },
                        isRequired: false
                    },
                    {
                        id: chooseManyId2,
                        sectionId,
                        name: 'What Stopped Me',
                        type: 'Choose Many',
                        minutes: 0,
                        isActive: true,
                        isVisible: false,
                        dataScope: 'solo',
                        startsOn: 1,
                        startsAfter: 'start',
                        transition: 'fade',
                        targetParticipantRole: 'noRole',
                        content: {
                            displayType: 'box',
                            description:
                                '<h2>1. Why didn\'t you do this small action?</h2><p>Choose any that apply and/or add thoughts in the "other" field.</p>',
                            options: [
                                {
                                    label: '<p>Forgot</p>',
                                    image: '',
                                    choice: uuid()
                                },
                                {
                                    label: '<p>Not enough time</p>',
                                    image: '',
                                    choice: uuid()
                                },
                                {
                                    label: '<p>Anxiety or fear</p>',
                                    image: '',
                                    choice: uuid()
                                },
                                {
                                    label: '<p>Never had an opportunity</p>',
                                    image: '',
                                    choice: uuid()
                                },
                                {
                                    label: '<p>Not sure how to do it</p>',
                                    image: '',
                                    choice: uuid()
                                },
                                {
                                    image: '',
                                    label: 'Other ',
                                    choice: uuid(),
                                    isOther: true
                                }
                            ]
                        }
                    },
                    {
                        id: chooseOneId,
                        sectionId,
                        name: "What I'm Thinking",
                        type: 'Choose One',
                        minutes: 0,
                        isActive: true,
                        isVisible: false,
                        dataScope: 'solo',
                        startsOn: 1,
                        startsAfter: 'start',
                        transition: 'fade',
                        targetParticipantRole: 'noRole',
                        content: {
                            displayType: 'radio',
                            description:
                                '<h2>2. When it comes to this small action, what are you thinking now?</h2><p>Choose the one that resonates most with you, or add your own in the "other" field.</p>',
                            options: [
                                {
                                    label: '<p>I want to do this action, but need to create a reminder or block time to do it.</p>',
                                    image: '',
                                    choice: uuid()
                                },
                                {
                                    label: '<p>I need to make some changes to this action to make it work for me.</p>',
                                    image: '',
                                    choice: uuid()
                                },
                                {
                                    label: '<p>I want to focus on learning from this action vs. worrying about getting it right.</p>',
                                    image: '',
                                    choice: uuid()
                                },
                                {
                                    label: "<p>I'm still planning to do this action when the time is right.</p>",
                                    image: '',
                                    choice: uuid()
                                },
                                {
                                    label: "<p>This action doesn't make sense for me right now so I'm dropping it.</p>",
                                    image: '',
                                    choice: uuid()
                                },
                                {
                                    image: '',
                                    label: 'Other ',
                                    choice: uuid(),
                                    isOther: true
                                }
                            ]
                        }
                    },
                    {
                        id: uuid(),
                        sectionId,
                        name: 'Review Your Responses',
                        type: 'Show Previous Answers',
                        minutes: 0,
                        isActive: true,
                        isVisible: false,
                        dataScope: 'solo',
                        startsOn: 1,
                        startsAfter: 'start',
                        transition: 'fade',
                        targetParticipantRole: 'noRole',
                        isRequired: false,
                        content: {
                            description:
                                "<p><strong>You can learn from not doing something.</strong> Take a minute to consider what you want to learn from this experience.</p><p>You'll have a chance to respond on the next screen.</p>",
                            questionsToDisplay: [
                                {
                                    id: '831df899-db85-4bdc-96d4-68389cf464ed',
                                    questionType: 'CHOOSE MANY',
                                    questionId: chooseManyId2
                                },
                                {
                                    id: 'bda42491-5cc7-45a0-bc3c-84b7f2f52aa8',
                                    questionType: 'CHOOSE ONE',
                                    questionId: chooseOneId
                                }
                            ]
                        }
                    },
                    {
                        id: uuid(),
                        sectionId,
                        name: 'Takeaway',
                        type: 'Short Essay',
                        minutes: 0,
                        isActive: true,
                        isVisible: false,
                        dataScope: 'solo',
                        startsOn: 1,
                        startsAfter: 'start',
                        transition: 'fade',
                        targetParticipantRole: 'noRole',
                        content: {
                            hideCharacterCount: true,
                            description:
                                "<h2>3. What is the main thing you want to take from this experience?</h2><p>There's no right answer. Your honest response helps you grow in the way that's best for you.</p><p>You can also use this space to make a plan for what's next — whether that's practicing this action on your own, changing it to work better for you, or dropping it for now.</p>"
                        }
                    },
                    {
                        id: uuid(),
                        sectionId,
                        name: 'Wrap Up',
                        type: 'Dynamic Rich Text',
                        minutes: 0,
                        isActive: true,
                        isVisible: false,
                        dataScope: 'solo',
                        startsOn: 1,
                        startsAfter: 'start',
                        transition: 'fade',
                        targetParticipantRole: 'noRole',
                        content: {
                            blocks: [
                                {
                                    id: uuid(),
                                    wrapText: true,
                                    layout: 'LEFT_TEXT_RIGHT_IMAGE',
                                    description:
                                        "<p>You're done!</p><p>Learning, taking action, and reflecting help you build leadership skills over time.</p>"
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    };
};

export const getTakeActionDefaults = (sectionId) => {
    const chooseOneId = uuid();
    const showPreviousId = uuid();
    return {
        name: 'Plan Your Small Action',
        subtitle: "Apply what you've learned in the real world. Choose a small action to try in this activity.",
        totalSectionItemCount: 1,
        durationId: 'dd83face710c4c70a5d2ef653c13571a',
        sections: [
            {
                id: sectionId,
                sectionIcon: 'asterisk',
                name: 'New Section',
                sectionItems: [
                    {
                        sectionId,
                        name: 'From Learning to Doing',
                        id: uuid(),
                        isActive: true,
                        type: 'Dynamic Rich Text',
                        startsAfter: 'start',
                        startsOn: 1,
                        targetParticipantRole: 'all',
                        content: {
                            blocks: [
                                {
                                    id: uuid(),
                                    layout: 'LEFT_TEXT_RIGHT_IMAGE',
                                    description:
                                        "<p>It's time to move from learning and practicing to taking action and applying in the real world.</p><p>Trying new things and learning from experience is a proven way to grow as a leader.</p>"
                                }
                            ]
                        }
                    },
                    {
                        id: chooseOneId,
                        sectionId,
                        name: 'My Action',
                        type: 'Choose One',
                        minutes: 0,
                        isActive: true,
                        isVisible: false,
                        isRequired: true,
                        dataScope: 'solo',
                        startsOn: 1,
                        startsAfter: 'start',
                        transition: 'fade',
                        targetParticipantRole: 'all',
                        content: {
                            displayType: 'radio',
                            description:
                                "<h2>Choose one small action that you'll do in the next two weeks, or create your own.</h2>",
                            options: [
                                {
                                    label: '',
                                    image: '',
                                    choice: uuid()
                                },
                                {
                                    label: '',
                                    image: '',
                                    choice: uuid()
                                },
                                {
                                    label: '',
                                    image: '',
                                    choice: uuid()
                                },
                                {
                                    label: '',
                                    image: '',
                                    choice: uuid()
                                },
                                {
                                    image: '',
                                    label: 'Other ',
                                    choice: uuid(),
                                    isOther: true
                                }
                            ]
                        }
                    },
                    {
                        id: showPreviousId,
                        sectionId,
                        name: 'My Why',
                        type: 'Show Previous Answers and Choose One',
                        minutes: 0,
                        isActive: true,
                        isVisible: false,
                        dataScope: 'solo',
                        startsOn: 1,
                        startsAfter: 'start',
                        transition: 'fade',
                        targetParticipantRole: 'all',
                        isRequired: true,
                        content: {
                            description:
                                "<p>Now that you've chosen a small action, consider why you're doing it.</p><h2>What do you want to gain from this action?</h2>",
                            questionsToDisplay: [
                                {
                                    id: uuid(),
                                    questionType: 'CHOOSE ONE',
                                    questionId: chooseOneId
                                }
                            ]
                        },
                        choiceContent: {
                            displayType: 'radio',
                            description: '<p>Select the "why" that most resonates with you, or add your own.</p>',
                            options: [
                                {
                                    label: '',
                                    image: '',
                                    choice: uuid()
                                },
                                {
                                    label: '',
                                    image: '',
                                    choice: uuid()
                                },
                                {
                                    label: '',
                                    image: '',
                                    choice: uuid()
                                },
                                {
                                    label: '',
                                    image: '',
                                    choice: uuid()
                                },
                                {
                                    image: '',
                                    label: 'Other ',
                                    choice: uuid(),
                                    isOther: true
                                }
                            ]
                        }
                    },
                    {
                        id: uuid(),
                        sectionId,
                        name: 'Commit to Your Action',
                        type: 'Show Previous Answers',
                        minutes: 0,
                        isActive: true,
                        isVisible: false,
                        dataScope: 'solo',
                        startsOn: 1,
                        startsAfter: 'start',
                        transition: 'fade',
                        targetParticipantRole: 'all',
                        isRequired: false,
                        content: {
                            description:
                                "<h2>Set yourself up for success.</h2><p>Record your small action where you'll see it every day, or tell a co-worker you've committed to doing it.</p>",
                            questionsToDisplay: [
                                {
                                    id: uuid(),
                                    questionType: 'CHOOSE ONE',
                                    questionId: chooseOneId
                                },
                                {
                                    id: uuid(),
                                    questionType: SECTION_ITEM_TYPES.SHOW_PREVIOUS_ANSWERS_CHOOSE_ONE,
                                    questionId: showPreviousId
                                }
                            ]
                        }
                    },
                    {
                        id: uuid(),
                        sectionId,
                        name: "What's Next",
                        type: 'Dynamic Rich Text',
                        minutes: 0,
                        isActive: true,
                        isVisible: false,
                        dataScope: 'solo',
                        startsOn: 1,
                        startsAfter: 'start',
                        transition: 'fade',
                        targetParticipantRole: 'all',
                        content: {
                            blocks: [
                                {
                                    id: uuid(),
                                    wrapText: true,
                                    layout: 'LEFT_TEXT_RIGHT_IMAGE',
                                    description:
                                        "<p>As you put your learning into action, Verb is here to support you.</p><p>We'll remind you about your small action over the next two weeks. Then you can reflect on Verb about how it went.</p><p>Every time you take a small action and reflect on how it went, you grow as a leader.</p><p>Are you ready?</p>"
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    };
};
